import { Route } from "react-router-dom";
import * as Sentry from "@sentry/react";

export const TraceRoute = Sentry.withSentryRouting(Route);
export const NoTraceRoute = Route;
